import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { storeToRefs } from 'pinia';
import { useMedia } from '@/store';
import VideosItem from './VideosItem.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Videos',
  setup(__props) {

const { isEnlarged } = storeToRefs(useMedia());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['videos', { 'not-scroll': _unref(isEnlarged) }])
  }, [
    _createVNode(VideosItem)
  ], 2))
}
}

})